// extracted by mini-css-extract-plugin
module.exports = {"container":"promoBanner-module--container--2RLg8","scrolling":"promoBanner-module--scrolling--Pfo4j","marquee":"promoBanner-module--marquee--1UVfy"};